import { render } from "./PublicProfileCard.vue?vue&type=template&id=20322986&scoped=true"
import script from "./PublicProfileCard.vue?vue&type=script&lang=js"
export * from "./PublicProfileCard.vue?vue&type=script&lang=js"

import "./PublicProfileCard.vue?vue&type=style&index=0&id=20322986&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20322986"]])

export default __exports__